import { createContext } from 'react';
export var ConnectionContext = /*#__PURE__*/createContext(null);
ConnectionContext.displayName = 'ConnectionContext';
export default ConnectionContext;
//# sourceMappingURL=ConnectionContext.js.map